export default __webpack_public_path__ + "f1b321170f4864d0615a3cf8169b7219.svg";